import React from 'react';
import { useHistory } from 'react-router-dom';
import { IonButton } from '@ionic/react';
import { PageLayout } from 'containers/layout';

function ThankyouPage() {
  const history = useHistory();
  return (
    <PageLayout hideHeader>
      <div className="full-height">
        <div className="center-flex-content ion-padding">
          <h3>Payment Successful!</h3>
          <p>You can view a copy of your receipt from the main menu.</p>
        </div>
        <div className="ion-padding">
          <IonButton
            color="secondary"
            expand="block"
            fill="solid"
            type="button"
            onClick={() => history.push('/locations')}
          >
            Done
          </IonButton>
        </div>
      </div>
    </PageLayout>
  );
}

export default ThankyouPage;
